import { Outlet } from "react-router-dom";
import { createContext, useContext, useState, useEffect } from "react";


export const PageTemplate = () => {
    return (
        <>
            <Outlet />
        </>
    );
};

const PageThemeContext = createContext();


export const DefaultPage = () => {
    const [theme, setTheme] = useState("light");
    
    const savedTheme = localStorage.getItem("app_theme");
    if (savedTheme) {
        document.documentElement.setAttribute('data_theme', savedTheme);
    } else {
        document.documentElement.setAttribute('data_theme', "light");
        localStorage.setItem("app_theme", "light");
    }

    useEffect(() => {
        const savedTheme = localStorage.getItem("app_theme");
        if (savedTheme) {
            document.documentElement.setAttribute('data_theme', savedTheme);
            setTheme(savedTheme);
        } else {
            document.documentElement.setAttribute('data_theme', "light");
            setTheme("light");
            localStorage.setItem("app_theme", "light");
        }
    }, []);

    const toggleTheme = () => {
        const newTheme = theme === "light" ? "dark" : "light";
        setTheme(newTheme);
        localStorage.setItem("app_theme", newTheme);
    };

    return (
        <PageThemeContext.Provider value={{ theme, toggleTheme }}>
            <PageTemplate />
        </PageThemeContext.Provider>
    );
};

export const useTheme = () => useContext(PageThemeContext);